import React, { useState } from 'react';
import PropTypes from 'prop-types';

const SimpleBudgetSummaryCard = ({ ctrl }) => {
  const [view, setView] = useState('internal');
  const { calculated, formatCalculatedNumber } = ctrl;

  const isInternal = view === 'internal';

  const grossTicketEstimated = isInternal
    ? (calculated?.ticketsSection?.externalForecastTotal || 0)
    : (calculated?.ticketsSection?.externalTotal || 0);
  const grossTicketActual = calculated?.ticketsSection?.externalActualTotal || 0;

  const taxesFeesEstimated = isInternal
    ? (calculated?.beforeAdjustedDeductionsSection?.externalForecastTotal || 0)
    : (calculated?.beforeAdjustedDeductionsSection?.externalTotal || 0);
  const taxesFeesActual = calculated?.beforeAdjustedDeductionsSection?.externalActualTotal || 0;

  // Net Gross
  const netGrossEstimated = isInternal
    ? (calculated?.showSummary?.netBoxOfficeReceiptsForecast || 0)
    : (calculated?.showSummary?.netBoxOfficeReceipts || 0);
  const netGrossActual = calculated?.showSummary?.netBoxOfficeReceiptsActual || 0;

  // Additional Internal Revenue — venue-only revenue (show_in_offer === false).
  // Ancillary income is forecast/actuals-only, so its estimate lives in the
  // forecast total (shows on the Internal/Forecast tab).
  const additionalInternalEstimated = isInternal
    ? (calculated?.revenueSection?.internalForecastTotal || 0)
    : (calculated?.revenueSection?.internalTotal || 0);
  const additionalInternalActual = calculated?.revenueSection?.internalActualTotal || 0;

  const fmt = (n) => formatCalculatedNumber(n);
  const fmtParens = (n) => {
    const val = Number(n || 0);
    const formatted = formatCalculatedNumber(Math.abs(val));
    return `(${formatted})`;
  };

  return (
    <div className="simple-offer-card">
      <div className="simple-offer-card__eyebrow">BUDGET SUMMARY</div>

      <div className="simple-seg">
        <button
          className={`simple-seg__btn${view === 'internal' ? ' simple-seg__btn--active' : ''}`}
          onClick={() => setView('internal')}
          type="button"
        >
          Internal
        </button>
        <button
          className={`simple-seg__btn${view === 'external' ? ' simple-seg__btn--active' : ''}`}
          onClick={() => setView('external')}
          type="button"
        >
          External
        </button>
      </div>

      <div className="simple-budget__rows">
        <div className="simple-budget__row">
          <div className="simple-budget__row-label">Gross Ticket Revenue</div>
          <div className="simple-budget__row-cols">
            <div className="simple-budget__col">
              <span className="simple-budget__value">{fmt(grossTicketEstimated)}</span>
              <span className="simple-budget__col-label">ESTIMATED</span>
            </div>
            <div className="simple-budget__col">
              <span className="simple-budget__value">{fmt(grossTicketActual)}</span>
              <span className="simple-budget__col-label">ACTUAL</span>
            </div>
          </div>
        </div>

        <div className="simple-budget__row">
          <div className="simple-budget__row-label">Taxes and Fees</div>
          <div className="simple-budget__row-cols">
            <div className="simple-budget__col">
              <span className="simple-budget__value">{fmtParens(taxesFeesEstimated)}</span>
              <span className="simple-budget__col-label">ESTIMATED</span>
            </div>
            <div className="simple-budget__col">
              <span className="simple-budget__value">{fmtParens(taxesFeesActual)}</span>
              <span className="simple-budget__col-label">ACTUAL</span>
            </div>
          </div>
        </div>

        <div className="simple-budget__row">
          <div className="simple-budget__row-label">Net Gross</div>
          <div className="simple-budget__row-cols">
            <div className="simple-budget__col">
              <span className="simple-budget__value">{fmt(netGrossEstimated)}</span>
              <span className="simple-budget__col-label">ESTIMATED</span>
            </div>
            <div className="simple-budget__col">
              <span className="simple-budget__value">{fmt(netGrossActual)}</span>
              <span className="simple-budget__col-label">ACTUAL</span>
            </div>
          </div>
        </div>

        <div className="simple-budget__row">
          <div className="simple-budget__row-label">Additional Internal Revenue</div>
          <div className="simple-budget__row-cols">
            <div className="simple-budget__col">
              <span className="simple-budget__value">{fmt(additionalInternalEstimated)}</span>
              <span className="simple-budget__col-label">ESTIMATED</span>
            </div>
            <div className="simple-budget__col">
              <span className="simple-budget__value">{fmt(additionalInternalActual)}</span>
              <span className="simple-budget__col-label">ACTUAL</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SimpleBudgetSummaryCard.propTypes = {
  ctrl: PropTypes.object.isRequired,
};

export default SimpleBudgetSummaryCard;
